import React from 'react';

export default () => (<div className="project" id="project-2">
  <div className="slogan">
    <img src={process.env.PUBLIC_URL + '/images/project/project-2-slogan.png'} alt="镇安秦岭山区5000亩树莓基地建设" />
  </div>
  <div className="content">
    <div id="constructions">
      <div className="title">
        <span>建设内容</span>
      </div>
      <div className="constructions">
        <div className="construction" id="construction-1">
          <div className="icon icon-project-construction-first"></div>
          <div className="name">
            <span>树莓的苗孵化</span>
          </div>
          <div className="desc">
            <span>全自动化温室</span>
            <span>快繁幼苗培育园</span>
            <span>优良品种亩本园</span>
          </div>
        </div>
        <div className="construction" id="construction-2">
          <div className="icon icon-project-construction-second"></div>
          <div className="name">
            <span>农村合作社的组建</span>
          </div>
          <div className="desc">
            <span>推广种植</span>
            <span>产销联合</span>
            <span>产品的深加工</span>
          </div>
        </div>
        <div className="construction" id="construction-3">
          <div className="icon icon-project-construction-third"></div>
          <div className="icon third"></div>
          <div className="name">
            <span>基础设施的建设</span>
          </div>
          <div className="desc">
            <span>道路的建设</span>
            <span>给排水的建设</span>
            <span>环境建设</span>
            <span>固定资产的投入</span>
          </div>
        </div>
      </div>
    </div>
    <div className="crossline-container">
      <div id="advantages">
        <div className="title">
          <div className="icon icon-project-advantages"></div>
          <div className="name">项目特色及优势</div>
        </div>
        <div className="advantage">
          <span>树莓苗的快繁技术，实现苗孵化的工厂化、快速化，技术含量高，可带动西北五省的树莓苗的需求，具体辐射带动作用。</span>
        </div>
        <div className="advantage">
          <span>经济价值高、可综合利用。树莓具有多种深加工产品，经济价值高，可综合利用，对周边农民的致富带动能力强。</span>
        </div>
        <div className="advantage">
          <span>集育苗、科研、种植、加工、观光一体化，具有功能复合性，可作物全国现代经济作物种植区的标版。基地及实验观光、育苗、推广种植、回收、深加工、销售为一体，产业链长，可发展潜力大，可做大做强，对产业链的拉伸具有较强的能力。</span>
        </div>
        <div className="advantage">
          <span>树莓的深加工带动周边经济作物的深加工，对镇安乃至秦岭山区的经济作物的产业的深加工具有带头作用。</span>
        </div>
        <div className="advantage">
          <span>基地实现有机化全产业链，对秦岭山区的生态保护起到带头示范作用。树莓具有防风固沙的作用，可推广陕北及全国范围内种植。</span>
        </div>
      </div>
    </div>
    <div id="extras">
      <div className="extra tech-flow-path">
        <div className="icon icon-project-tech-features"></div>
        <div className="title">
          技术流程
      </div>
        <div className="desc">
          <div>技术培训 -> 农户种植 -> 标准化管理 -> 产品检测 -> 产品合格 -> 公司回收 -></div>
          <div>冷冻储藏 -> 深加工 -> 市场销售</div>
        </div>
      </div>
      <div className="extra target">
        <div className="icon icon-project-tech-advantages"></div>
        <div className="title">
          未来发展目标
      </div>
        <div className="desc">
          <div>
            <span>现代农业</span><span>产值过亿</span>
          </div>
          <div>
            <span>全程有机</span><span>全产业链</span>
          </div>
          <div>
            <span>带动示范</span><span>高科技</span>
          </div>
        </div>
      </div>
    </div>
    <div className="background"></div>
  </div>
</div>
);